const InvestmentTermType = {
  month: 'hónap',
  year: 'év'
}
export default InvestmentTermType
